import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useTheme,
  Chip,
  Box,
} from "@mui/material";
import moment from "moment";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomCard from "../../components/@extended/CustomCard";
import {
  CustomTableHead,
  CustomTableHeadCell,
} from "../../components/@extended/CustomTable";
import { useGetOnHoldSubjectListQuery } from "../../store/slices/apiSlice";
import { getUserRole } from "../util";
import CustomTablePagination from "../../components/common/TablePagination";
import { updatePagination } from "../../store/slices/applicationSlice";

const SubjectOnHoldListCard = ({ trialId, sponsorId, siteId, trialSiteId }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { page, rowsPerPage } = useSelector((state) => state.application.pagination.ON_HOLD_SUBJECT_TABLE);
  const { data: subjectList } = useGetOnHoldSubjectListQuery({
    trialId,
    sponsorId,
    siteId,
  });
  const user = useSelector((state) => state.auth.user);
  const userData = useSelector((state) => state.auth.userData);
  const userRole = getUserRole(user, trialId, siteId, userData);

  const columns = useMemo(() => {
    if (subjectList) {
      return [
        {
          id: 'participantId',
          label: 'Participant ID',
          minWidth: 200,
          align: 'center',
        },
        // {
        //   id: 'status',
        //   label: 'Status',
        //   minWidth: 150,
        //   align: 'center',
        // },
        {
          id: 'createdAt',
          label: 'Created Date',
          minWidth: 150,
          align: 'center',
        },
        {
          id: 'updatedAt',
          label: 'On Hold Since',
          minWidth: 150,
          align: 'center',
        },
      ];
    }
    return [];
  }, [subjectList]);

  const handleNavigate = (subjectMasterId) => {
    navigate(`/eConcent/${trialId}/trial-site/${trialSiteId}/site/${siteId}/subject/${subjectMasterId}/details`, {});
  };

  const onNewPage = (page, rowsPerPage) => {
    dispatch(updatePagination({ tableType: 'ON_HOLD_SUBJECT_TABLE', page, rowsPerPage }));
  };

  return (
    <Box sx={{ flex: 1, height: '100%' }}>
    <CustomCard
      title={"Screened Eligible – Reserved for Balancing"}
      subHeader={`Total: ${subjectList?.length || 0}`}
      sx={{
        p: 1,
        pt: 2,
        paddingBottom: 0,
        '&:last-child': {
          paddingBottom: 0,
        },
        flex: 1,
        minWidth: 0,
      }}
    >
      <TableContainer
        sx={{
          border: `1px ${theme.palette.grey[100]} solid `,
        }}
      >
        <Table stickyHeader>
          <CustomTableHead>
            <TableRow>
              {columns &&
                columns.map((column) => {
                  return (
                    <CustomTableHeadCell key={column.id} align={column.align} width={column.minWidth}>
                      {column.label}
                    </CustomTableHeadCell>
                  );
                })}
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {!subjectList || subjectList?.length === 0 ? (
              <TableRow>
                <TableCell align={'center'} colSpan={4}>
                  <Typography variant="subtitle1" color="initial">
                    No subjects on hold.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              columns &&
              (rowsPerPage > 0
                ? subjectList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : subjectList
              ).map((subject, index1) => {
                return (
                  <TableRow tabIndex={-1} key={index1} hover sx={{ cursor: 'pointer' }}>
                    {columns.map((column) => {
                      let value;
                      switch (column.id) {
                        case 'createdAt':
                        case 'updatedAt':
                          value = moment(subject[column.id]).format('DD/MM/YYYY');
                          break;
                        case 'status':
                          value = (
                            <Chip
                              label="On Hold"
                              size="small"
                              sx={{
                                backgroundColor: theme.palette.warning.light,
                                color: theme.palette.warning.dark,
                                fontWeight: 600,
                              }}
                            />
                          );
                          break;
                        default:
                          value = subject[column.id];
                          break;
                      }
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          onClick={() => {
                            handleNavigate(subject.id);
                          }}
                        >
                          {value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {subjectList && subjectList.length > 0 && (
        <CustomTablePagination page={page} rowsPerPage={rowsPerPage} count={subjectList.length} onNewPage={onNewPage} />
      )}
    </CustomCard>
    </Box>
  );
};

export default SubjectOnHoldListCard;

